import React, { useRef, useState } from "react";

import { Input } from "lib/components/Input";
import { CheckboxButton } from "lib/components/Checkbox";
import { KeyValue } from "lib/components/KeyValue";
import { fetchData } from "lib/helpers/fetchData";

import { getFormValues } from "lib/helpers/getFormValues";
import { StyledForm } from "lib/styles/general";

import { CTAButton } from "lib/components/CTAButton";
import { getApiUrl } from "lib/helpers/getApiUrl";

export const Phish = ({ data, reload }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);

  const handleSubmit = async () => {
    setIsLoading(true);
    let { enabled, domains, cc, useBrandlessTemplate } = getFormValues(formRef.current);
    domains = domains
      ?.toString()
      ?.split(",")
      ?.map((d) => d.trim())
      ?.filter(Boolean);

    await fetchData(
      `${getApiUrl("ADMIN_API")}/customers/${data.id}/apps/phish`,
      JSON.stringify({ enabled, domains, cc, useBrandlessTemplate }),
      "PUT"
    );
    setIsLoading(false);
    setIsEditMode(false);
    reload();
  };

  const handleExit = () => setIsEditMode(false);

  return (
    <div style={{ position: "relative" }}>
      {!isEditMode && (
        <CTAButton style={{ position: "absolute", right: 0, top: 0, zIndex: 99 }} onClick={() => setIsEditMode(!isEditMode)}>
          Edit
        </CTAButton>
      )}
      <StyledForm ref={formRef}>
        <section style={{ paddingTop: 0 }}>
          <KeyValue
            text="Service Status"
            wrap={false}
            value={
              <CheckboxButton
                name="enabled"
                subtle
                showWhenNull
                label={!isEditMode ? (data?.apps?.phish?.enabled ? "Enabled" : "Disabled") : "Is Enabled?"}
                defaultChecked={!!data?.apps?.phish?.enabled}
                readOnly={!isEditMode}
              />
            }
          />
          <KeyValue
            text="Use Brandless Template"
            wrap={false}
            value={
              <CheckboxButton
                name="useBrandlessTemplate"
                subtle
                showWhenNull
                label={!isEditMode ? (data?.apps?.phish?.useBrandlessTemplate ? "Enabled" : "Disabled") : "Use Brandless Template?"}
                defaultChecked={!!data?.apps?.phish?.useBrandlessTemplate}
                readOnly={!isEditMode}
              />
            }
          />
          <Input name="domains" label="Domain(s)" defaultValue={data?.apps?.phish?.domains?.join(", ")} readOnly={!isEditMode} />
          {isEditMode && (
            <p style={{ fontStyle: "italic", color: "#FF585B", marginTop: 0 }}>
              Warning: Please do not configure the same email domain for multiple customers, as this is not currently supported.
            </p>
          )}
          <Input name="cc" type="email" label="CC" defaultValue={data?.apps?.phish?.cc} readOnly={!isEditMode} />
        </section>
      </StyledForm>
      {isEditMode && (
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1rem" }}>
          <CTAButton isSecondary onClick={handleExit}>
            Cancel
          </CTAButton>
          <CTAButton isLoading={isLoading} onClick={handleSubmit}>
            Save
          </CTAButton>
        </div>
      )}
    </div>
  );
};
